import React, { useState, useEffect, useRef } from "react";
import {
  TableContainer,
  Paper,
  Typography,
  Box,
  PaginationItem,
} from "@mui/material";
import { api, get, post } from "../../../../utils/api";
import { styled } from "@mui/material/styles";
import PaginationBox from "../../../../Components/Masters/Pagination";
import DeleteDialog from "../../../../Components/Masters/DeleteDialog";
import ColumnHeadings from "../../../../Components/Masters/ColumnHeadings";
import MenuActions from "../../../../Components/Masters/MenuActions";
import TableContent from "../../../../Components/Masters/TableContent";
import FilterDrawer from "../../../../Components/Masters/FilterDrawer";
import TopMenu from "../../../../Components/Masters/TopMenu";
import MessagePopup from "../../../../Components/Masters/MessagePopup";
import TableHeading from "../../../../Components/Masters/TableHeading";
import MenuIcon from "../../../../Components/Masters/MenuIcon";
import { companyId } from "../../../../utils/companyId";
import MultiSelect from "../../../Masters/Roles and Permissions/Filters/MultiSelect";
import Range from "../../../Masters/Roles and Permissions/Filters/Range";
import Cards from "../../../../Components/Common/Cards";
import NoDataFound from "../../../../Components/Masters/NoDataFound";
import ViewData from "./ViewData";
import AddData from "./AddData";
import { getMonthName } from "../../../../utils/getMonthName";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import Scope3Layout from "../../../../Layout/Scope3Layout";
import { categoryData } from "./categoryData";
import MonthYearFilter from "../../../Masters/Roles and Permissions/Filters/MonthYearFilter";
import Unauthorized from "../../../../Components/Unauthorized/Unauthorized";
import TopMenuUpload from "../../../../Components/Masters/TopMenuUpload";
import BulkUploadModal from "../../../../Components/Common/BulkUploadModal";
import DateRangePickerComponent from "../../../Masters/Roles and Permissions/Filters/Date";
import { formatNumber } from "../../../../utils/formatNumber";
import { truncateNumber } from "../../../../utils/common";
import GroupAdminSidebar from "../../../../Layout/GroupAdminSidebar";
import { useUser } from "../../../../context/AuthContext";
import FugitiveBulkUpload from "../../../Scope1/FugitiveEmmissions/FugitiveBulkUpload";
import EmissionBulkAdd from "./EmissionBulkAdd";
import DeleteAlertDialog from "../../../../Components/Masters/DeleteAlertDialog";
const Emissions = () => {
  const { user } = useUser();
  const [cardData, setCardData] = useState(null);
  const [selectedTypeOfActivity, setSelectedTypeOfActivity] = useState("");
  const [data, setData] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: "createdAt",
    direction: "desc",
  });

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedData, setSelectedData] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [addData, setAddData] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState({
    Date: false,
    "Purchased Month": false,
    "Name of Activity": false,
    "Category Type": false,
    "Type of Activity": false,
    "Amount Spend": false,
    // "Quantity Bought": false,
  });
  const columnWidth = "12% 15% 23% 25% 15% 10%";
  const [viewData, setViewData] = useState(false);
  const [element, setElement] = useState(null);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [limit] = useState(10); // Number of items per page
  const [selectedFilter, setSelectedFilter] = useState("Date");
  const [drawerFilterOpen, setDrawerFilterOpen] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [startMonth, setStartMonth] = useState(null);
  const [endMonth, setEndMonth] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [uniqueValues, setUniqueValues] = useState({});
  const [errors, setErrors] = useState({
    Date: false,
    "Purchased Month": false,
    "Name of Activity": false,
    "Category Type": false,
    "Type of Activity": false,
    "Amount Spend": false,
    // "Quantity Bought": false,
  });
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [selectedFields, setSelectedFields] = useState({
    activityName: [],
    categoryType: [],
    typeOfActivity: [],
  });
  const [quantityRange, setQuantityRange] = useState({ min: "", max: "" });
  const [amountRange, setAmountRange] = useState({ min: "", max: "" });

  const [bulkUploadModal, setBulkUploadModal] = useState(false);
  const [excelData, setExcelData] = useState(null);
  const [bulkUploadTable, setBulkUploadTable] = useState(false);
  const [formDataBulkUpload, setFormDataBulkUpload] = useState({});
  const [matchData, setMatchData] = useState([]);
  const [jsonBulkUpload, setJsonBulkUpload] = useState([]);
  // const [uploadErrorClose, setUploadErrorClose] = useState(false);
  const [options1, setOptions1] = useState([]);
  const [options2, setOptions2] = useState([]);

  const uploadErrorClose = () => {
    setBulkUploadTable(true);
  };

  const fetchExcelData = async () => {
    await get("/scope3/emission/generatePurchaseGoodServiceExcel")
      .then((res) => {
        const data = res?.data?.purchaseData || [];
        console.log("Vendor Data:", data);
        const typeOfActivity = uniqueValues?.typeOfActivity?.filter(
          (el) => el !== "Others",
        );
        // Generate a row for each vendor × category combination
        console.log(
          "typeOfActivity",
          typeOfActivity,
          uniqueValues?.typeOfActivity,
        );
        let arr = [];
        data?.forEach((vendor, vendorIndex) => {
          typeOfActivity?.forEach((type, i) => {
            arr.push({
              "Month (in 01/25 or Jan-25)": "",
              Vendor: vendor?.vendorLegalName,
              "Type of Activity": type,
              "Category Type": "", // Assign one category per row
              "Name of Activity": "",
              "Amount Spend": "",
              "Quantity Bought (in Tonnes)": "",
              "Remark (optional)": "",
            });
          });
        });

        setExcelData(arr);
      })
      .catch((err) => {
        console.error("Error fetching vendor data:", err);
      });
  };

  useEffect(() => {
    fetchExcelData();
  }, []);

  useEffect(() => {
    fetchCardData(selectedTypeOfActivity || uniqueValues?.typeOfActivity?.[0]);
  }, [selectedTypeOfActivity]);

  const fetchCardData = async (wasteMethod) => {
    try {
      let response = await get(`/scope3/emission/cardData`, {
        params: { typeOfActivity: selectedTypeOfActivity },
      });
      setCardData(response.data.data);
    } catch (error) {
      console.error("Error fetching card data:", error);
    }
  };

  const updatePage = () => {
    if (page > 1 && data.length === 1) {
      setPage(page - 1);
    }
    fetchData();
  };

  let bannerData = [
    {
      title: "Total Amount Spent",
      description: formatNumber(cardData?.totalAmountSpent) || 0,
      unit: "USD",
    },
    {
      title: "Amount Spent On",
      filter: "option",
      key: "typeOfActivity",
      filterValues: uniqueValues.typeOfActivity,
      defaultValue: selectedTypeOfActivity || "",
      description: formatNumber(cardData?.amountSpendOn[0]?.totalSpent) || 0,
      unit: "USD",
    },
    {
      title: "Top Purchased Items",
      description: cardData?.topPurchasedItems.map((el) => el.activityName),
      // key: "wasteManagedByMethod",
      // filterValues: filters?.wasteManagementMethod,
      // defaultValue: cardData?.wasteManagedByMethod?._id,
    },
  ];
  const tableContainerRef = useRef(null); // Reference to the table container
  const [isShortContent, setIsShortContent] = useState(false);

  useEffect(() => {
    const container = tableContainerRef.current;
    if (container) {
      const tableHeight = container.scrollHeight; // Get the table's height
      const screenHeight = window.innerHeight; // Get the viewport height

      // If table content is less than half the screen height, set pagination to be at the bottom
      setIsShortContent(tableHeight < screenHeight / 3);
    }
  }, [data]);

  const filters = [
    "Date",
    "Purchased Month",
    "Name of Activity",
    "Category Type",
    "Type of Activity",
    "Amount Spend",
    // "Quantity Bought",
  ];

  const inputData = [
    {
      fieldName: "consumptionPeriod",
      title: "Purchased Month",
      required: true,
      type: "date",
    },
    {
      fieldName: "purchaseVendor",
      title: "Vendor",
      placeholder: "Select vendor",
      type: "select",
      url: `${api}/master/purchasedGoods`, // Assuming this API will provide the vendor list.
      field: "vendorLegalName",
      required: true,
    },
    {
      fieldName: "activityName",
      title: "Name of Activity",
      placeholder: "Enter activity name",
      type: "text",
      required: true,
    },
    {
      fieldName: "categoryType",
      title: "Category Type",
      placeholder: "Select category type",
      type: "search",
      field: "categoryType",
      required: true,
      options: categoryData,
      autoFetchLabel: "Auto fetch",
    },
    {
      fieldName: "typeOfActivity",
      title: "Type of Activity",
      placeholder: "Select activity type",
      type: "select",
      options: [
        // ...new Set([
        //   ...(Array.isArray(uniqueValues.typeOfActivity) ? uniqueValues.typeOfActivity : []),
        "Production Materials",
        "Finished Goods",
        "Transportation and Distribution (not included in Upstream and Downstream Transportation and Distribution category)",
        "Information Technology and Communication",
        "Professional Services",
        "Others",
        // ])
      ],
      required: true,
    },
    {
      fieldName: "amountSpend",
      title: "Amount Spend",
      placeholder: "Enter amount spent",
      type: "number",
      required: true,
      nested: true,
      // options: ["USD", "INR", "EUR"], // Example of currency units
      adornmentText: "USD", // The unit could be currency
    },
    {
      fieldName: "quantityBought",
      title: "Quantity Bought (optional)",
      placeholder: "Enter quantity",
      type: "number",
      nested: true,
      required: true,
      // adornmentText: "KG",
      // The unit could be currency
      // field: "unit",
      options: ["Kg", "Liters", "Pound", "Gallon", "Item", "Pcs"], // Example of possible units
    },

    {
      fieldName: "remark",
      title: "Remark (optional)",
      placeholder: "Enter additional remarks",
      type: "text",
    },
    {
      fieldName: "editRemarkReason",
      title: "Edit Remark Reason",
      placeholder: "Additional edit remarks",
      type: "text",
      condition: true,
    },
    {
      fieldName: "documents",
      title: "Upload Documents (optional)",
      type: "file",
    },
  ];

  const fetchUniqueValues = async () => {
    // Extract unique values for "Category Type"
    try {
      let response = await get(`/scope3/emission/get`);
      const data = response.data.data;

      const uniqueActivityName = [
        ...new Set(
          data?.map((el) => el.activityName).filter(Boolean), // Assuming categoryType is a property of the object
        ),
      ];

      const uniqueCategoryTypes = [
        ...new Set(
          data?.map((el) => el.categoryType).filter(Boolean), // Assuming categoryType is a property of the object
        ),
      ];

      // Extract unique values for "Name of the activity"
      const uniqueTypeOfActivity = [
        ...new Set(
          data?.map((el) => el.typeOfActivity).filter(Boolean), // Assuming nameOfTheActivity is a property of the object
        ),
      ];

      setSelectedTypeOfActivity(
        selectedTypeOfActivity || uniqueTypeOfActivity[0],
      );
      return {
        activityName: uniqueActivityName,
        categoryType: uniqueCategoryTypes,
        typeOfActivity: uniqueTypeOfActivity,
      };
    } catch (error) {
      console.error("Error fetching unique values:", error);
      return {};
    }
  };

  // fetching Vehicle data
  const fetchData = async (
    filters = isFiltersApplied ? filtersToApply : {},
  ) => {
    try {
      console.log(filters);
      fetchCardData(selectedTypeOfActivity);
      const queryParams = new URLSearchParams({
        ...filters,
        page, // Add the current page
        limit: rowsPerPage, // Add the number of rows per page
        sortField: sortConfig.key, // Sort configuration
        sortOrder: sortConfig.direction,
        company: companyId,
        createdBy: companyId,
      }).toString();

      console.log("filters", filters);

      const response = await get(`/scope3/emission/get?${queryParams}`);

      setData(response.data.data);
      console.log(response.data.data);
      setTotalPages(response.data.totalPages); // Update total pages for pagination
      const uniqueValues = await fetchUniqueValues();
      setUniqueValues(uniqueValues);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, rowsPerPage, sortConfig]);

  const handleMenuClick = (event, element) => {
    setAnchorEl(event.currentTarget);
    setSelectedData(element);
    setElement(element);
    console.log(element);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedData(null);
  };

  const handleEdit = () => {
    handleMenuClose();
    setAddData(true);
    setViewData(false);
  };

  const handleView = () => {
    handleMenuClose();
    setViewData(true);
    setAddData(false);
  };

  const handleDelete = () => {
    handleMenuClose();
    setDeleteDialog(true);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const filtersToApply = {
    startDate: startDate ? startDate.format("YYYY-MM-DD") : "",
    endDate: endDate ? endDate.format("YYYY-MM-DD") : "",
    startMonth: startMonth ? startMonth.format("YYYY-MM") : "",
    endMonth: endMonth ? endMonth.format("YYYY-MM") : "",
    ...Object.keys(selectedFields).reduce((acc, key) => {
      const selectedOptions = selectedFields[key];

      // Check if there are selected options
      if (selectedOptions && selectedOptions.length > 0) {
        // Join options into a string or keep them as an array
        console.log(key);
        acc[key] = selectedOptions.join(key === "categoryType" ? "|" : ","); // Change to an array if needed
      }
      return acc;
    }, {}),
    // minQuantity: quantityRange.min || "",
    // maxQuantity: quantityRange.max || "",
    minAmount: amountRange.min || "",
    maxAmount: amountRange.max || "",
  };

  // function to validate filters
  const validateFilters = () => {
    let isValid = true;
    const newErrors = {
      Date: false,
      "Name of Activity": false,
      "Category Type": false,
      "Type of Activity": false,
      "Amount Spend": false,
      // "Quantity Bought": false,
    };

    console.log(selectedFilter, "hi");

    if (selectedFilter === "Quantity Bought") {
      const min = parseFloat(quantityRange.min);
      const max = parseFloat(quantityRange.max);

      if (min && isNaN(min)) {
        newErrors["Quantity Bought"] = "Min quantity must be a valid number";
        isValid = false;
      }

      if (max && isNaN(max)) {
        newErrors["Quantity Bought"] = "Max quantity must be a valid number";
        isValid = false;
      }

      if (!isNaN(min) && !isNaN(max) && min > max) {
        newErrors["Quantity Bought"] =
          "Min quantity cannot be greater than max Quantity";
        isValid = false;
      }
    }
    if (selectedFilter === "Amount Spend") {
      const min = parseFloat(amountRange.min);
      const max = parseFloat(amountRange.max);

      if (min && isNaN(min)) {
        newErrors["Amount Spend"] = "Min amount must be a valid number";
        isValid = false;
      }

      if (max && isNaN(max)) {
        newErrors["Amount Spend"] = "Max amount must be a valid number";
        isValid = false;
      }

      if (!isNaN(min) && !isNaN(max) && min > max) {
        newErrors["Amount Spend"] =
          "Min amount cannot be greater than max amount";
        isValid = false;
      }
    }

    setErrors(newErrors);
    return isValid;
  };

  // Applying selected filters
  const handleApplyFilters = () => {
    console.log(selectedFields);
    if (!validateFilters()) return;
    setPage(1);
    console.log(filtersToApply);
    fetchData(filtersToApply);
    handleAppliedFilters();
    setDrawerFilterOpen(false);
  };

  const handleResetFilters = async () => {
    // Reset local state for date selection and selected fields
    setStartDate(null);
    setEndDate(null);
    setStartMonth(null);
    setEndMonth(null);
    setSelectedFields({
      activityName: [],
      typeOfACtivity: [],
      categoryType: [],
    });
    setQuantityRange({ min: "", max: "" });
    setAmountRange({ min: "", max: "" });

    // Call fetchData without any filters
    await fetchData({});
    setErrors({});
    setAppliedFilters({});
    setIsFiltersApplied(false);
    setDrawerFilterOpen(false);
  };

  const handleAppliedFilters = () => {
    const isDateApplied = startDate || endDate;
    const isMonthApplied = startMonth || endMonth;
    const isNameOfActivityApplied = selectedFields.activityName?.length > 0;
    const isTypeOfActivityApplied = selectedFields.typeOfActivity?.length > 0;
    const isCategoryTypeApplied = selectedFields.categoryType?.length > 0;
    const isQuantityRangeApplied = quantityRange.min && quantityRange.max;
    const isAmountRangeApplied = amountRange.min || amountRange.max;

    setIsFiltersApplied(
      isDateApplied ||
        isMonthApplied ||
        isNameOfActivityApplied ||
        isTypeOfActivityApplied ||
        isCategoryTypeApplied ||
        isQuantityRangeApplied ||
        isAmountRangeApplied,
    );

    setAppliedFilters((prevAppliedFilters) => ({
      ...prevAppliedFilters,
      Date: isDateApplied,
      "Purchased Month": isMonthApplied,
      "Name of Activity": isNameOfActivityApplied,
      "Category Type": isCategoryTypeApplied,
      "Type of Activity": isTypeOfActivityApplied,
      "Amount Spend": isAmountRangeApplied,
      // "Quantity Bought": isQuantityRangeApplied,
    }));
  };

  // Handle Sorting function
  const handleSort = (column, direction) => {
    setSortConfig({ key: column, direction });
  };

  const StyledPaginationItem = styled(PaginationItem)(({ theme }) => ({
    "&.Mui-selected": {
      backgroundColor: "green",
      color: "#fff",
      fontWeight: "bold",
    },
    "&:hover": {
      backgroundColor: "#ededed",
    },
  }));

  const handleFilterDrawer = () => {
    setDrawerFilterOpen(false);
    setStartDate(appliedFilters?.Date ? startDate : null);
    setEndDate(appliedFilters?.Date ? endDate : null);
    setStartMonth(appliedFilters?.Month ? startMonth : null);
    setEndMonth(appliedFilters?.Month ? endMonth : null);
    setAmountRange({
      min: appliedFilters?.["Amount Spend"] ? amountRange?.min : null,
      max: appliedFilters?.["Amount Spend"] ? amountRange?.max : null,
    });
    setSelectedFields(
      {
        typeOfActivity: appliedFilters?.["Type of Activity"]
          ? selectedFields?.typeOfActivity
          : [],
      },
      {
        activityName: appliedFilters?.["Name of Activity"]
          ? selectedFields?.activityName
          : [],
      },
      {
        categoryType: appliedFilters?.["Category Type"]
          ? selectedFields?.categoryType
          : [],
      },
    );
    // setErrors({ Date: false, Role: false });
  };

  const handleActivityChange = (key, value, filterType) => {
    setSelectedTypeOfActivity(value);
  };

  const headers = [
    { key: "createdAt", label: "Date", sortable: true },
    { label: "Purchased Month", key: "consumptionPeriod", sortable: true },
    { key: "typeOfActivity", label: "Type of Activity", sortable: true },
    { key: "activityName", label: "Name of Activity", sortable: true },
    {
      key: "amountSpend",
      label: "Amount Spend(USD)",
      sortable: true,
      field: "value",
    },
    // {
    //   key: "quantityBought",
    //   label: "Quantity Bought",
    //   sortable: true,
    //   field: "value",
    // },
    // { key: "unit", label: "Vendor Name", sortable: true },
  ];

  // Function to render the selected filter component based on user's choice
  const renderSelectedFilter = () => {
    switch (selectedFilter) {
      case "Date":
        return (
          <DateRangePickerComponent
            url={`${api}/scope3/emission/get`}
            {...{
              startDate,
              endDate,
              setStartDate,
              setEndDate,
              setErrors,
              errors: errors.Date,
            }}
          />
        );
      case "Purchased Month":
        return (
          <MonthYearFilter
            {...{
              title: "Purchased Month",
              startMonth,
              endMonth,
              setStartMonth,
              setEndMonth,
              setErrors,
              errors: errors.Month,
            }}
          />
        );
      case "Name of Activity":
        return (
          <MultiSelect
            title="Name of Activity"
            selectedField={selectedFields.activityName}
            selectedFields={selectedFields}
            setSelectedFields={setSelectedFields}
            errors={errors["Name of Activity"]}
            setErrors={setErrors}
            field="activityName"
            data={uniqueValues.activityName}
          />
        );
      case "Category Type":
        return (
          <MultiSelect
            title="Category Type"
            selectedField={selectedFields.categoryType}
            selectedFields={selectedFields}
            setSelectedFields={setSelectedFields}
            errors={errors["Category Type"]}
            setErrors={setErrors}
            field="categoryType"
            data={uniqueValues.categoryType}
          />
        );
      case "Type of Activity":
        return (
          <MultiSelect
            title="Type of Activity"
            selectedField={selectedFields.typeOfActivity}
            selectedFields={selectedFields}
            setSelectedFields={setSelectedFields}
            errors={errors["Type of Activity"]}
            setErrors={setErrors}
            field="typeOfActivity"
            data={uniqueValues.typeOfActivity}
          />
        );

      case "Quantity Bought":
        return (
          <Range
            title="Quantity Bought"
            selectedRange={quantityRange}
            setSelectedRange={setQuantityRange}
            errors={errors["Quantity Bought"]}
            setErrors={setErrors}
            placeholderMax="Max (Unit)"
            placeholderMin="Min (Unit)"
          />
        );
      case "Amount Spend":
        return (
          <Range
            title="Amount Spend"
            selectedRange={amountRange}
            setSelectedRange={setAmountRange}
            errors={errors["Amount Spend"]}
            setErrors={setErrors}
            placeholderMin="Min (USD)"
            placeholderMax="Max (USD)"
          />
        );
      default:
        return (
          <DateRangePickerComponent
            url={`${api}/scope3/emission/get`}
            {...{
              startDate,
              endDate,
              setStartDate,
              setEndDate,
              setErrors,
              errors: errors.Date,
            }}
          />
        );
    }
  };

  const handleCloseBulkUpload = () => {
    setBulkUploadModal(false);
    fetchData();
  };

  // const onConfirm = async () => {
  //   try {
  //     const excelData = Object.values(formDataBulkUpload);
  //     console.log(excelData, "excelData to send");
  //     const response = await post(`/scope3/emission/jsonupload`, { excelData });
  //     setBulkUploadTable(false);
  //     fetchData();
  //     setsnackOpen({
  //       open: true,
  //       message: "Bulk upload completed successfully!",
  //       severity: "success",
  //     });
  //   } catch (error) {
  //     console.log(error, "error");
  //   }
  // };

  return (
    <MainDashboardLayout
      sidebar={user?.groupManager ? <GroupAdminSidebar /> : <Scope3Layout />}
    >
      <Unauthorized requiredModule="Environment | Scope 3 | Purchased">
        <Box
          sx={{
            backgroundColor: "#ededed",
          }}
        >
          <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
          {/*Message popup for success or failure */}
          {/* View log, Edit, delete menus */}
          <AddData
            id={element ? element._id : ""}
            title="Purchased Goods & Services"
            addUrl={`${api}/scope3/emission/add`}
            updateUrl={`${api}/scope3/emission/update`}
            {...{
              fetchData,
              setsnackOpen,
              uniqueValues,
              inputData,
              data,
              element,
              addData,
              setAddData,
            }}
          />
          <ViewData
            id={element ? element._id : ""}
            title={"Purchased Goods & Services"}
            {...{
              element,
              viewData,
              setViewData,
              inputData,
              handleEdit,
              companyAdmin: user?.companyAdmin,
            }}
          />
          <Cards
            data={bannerData}
            title={"Purchased Goods & Services"}
            onFilterChange={handleActivityChange}
          />
          {deleteDialog && (
            <DeleteAlertDialog
              fetchData={updatePage}
              {...{
                deleteDialog,
                setDeleteDialog,
                id: element._id,
                url: `${api}/scope3/emission/delete`,
                setsnackOpen,
                fetchCardData,
              }}
            />
          )}
          {/* Filter Drawer */}
          {/* <Toolbar sx={{ padding: "0 16px", marginBottom: "20px" }}> */}
          {drawerFilterOpen && (
            <FilterDrawer
              {...{
                renderSelectedFilter,
                drawerFilterOpen,
                setDrawerFilterOpen,
                handleApplyFilters,
                handleFilterDrawer,
                setSelectedFilter,
                handleResetFilters,
                selectedFilter,
                filters,
                appliedFilters,
                startDate,
                startMonth,
                endDate,
                endMonth,
                selectedFields,
                setSelectedFields,
              }}
            />
          )}
          {/* Top Box for Heading, Filter Button, Add Data Button */}
          <TopMenuUpload
            setData={setElement}
            setAddData={setAddData}
            {...{
              // heading: "Coal",
              setBulkUploadModal,
              setDrawerFilterOpen,
              filterApplied: isFiltersApplied,
            }}
          />
          <TableContainer
            component={Paper}
            sx={{ maxWidth: "100%", marginBottom: "1.5rem" }}
            ref={tableContainerRef}
          >
            <Box>
              <TableHeading heading={"Emissions"} />
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: columnWidth,
                  borderBottom: "1px solid #ddd",
                  borderTop: "1px solid #ddd",
                }}
              >
                {headers.map((el) => (
                  <ColumnHeadings
                    key={el}
                    {...{
                      title: el.label,
                      key: el.label,
                      handleSort,
                      field: el.key,
                      sortConfig,
                    }}
                  />
                ))}
                <Typography
                  sx={{
                    fontWeight: "bold",
                    padding: "8px 12px",
                    textAlign: "center",
                  }}
                >
                  Action
                </Typography>
              </Box>
              {data.length === 0 ? (
                <NoDataFound />
              ) : (
                data.map((item) => (
                  <Box
                    key={item._id}
                    sx={{
                      display: "grid",
                      gridTemplateColumns: columnWidth,
                      borderBottom: "1px solid #ddd",
                    }}
                  >
                    {headers.map((el) => (
                      <TableContent
                        key={el.key}
                        {...{
                          fieldData:
                            el.key === "consumptionPeriod"
                              ? getMonthName(item[el.key]?.month) +
                                " " +
                                item[el.key]?.year
                              : el.key === "quantityBought"
                                ? item[el.key].value + " " + item[el.key].unit
                                : el.key === "amountSpend"
                                  ? truncateNumber(item[el.key].value)
                                  : el.field
                                    ? item[el.key].value
                                    : item[el.key],
                          dateField:
                            el.key === "createdAt" ? item.createdAt : false,
                        }}
                      />
                    ))}
                    {/* Menu Action Icon */}
                    <MenuIcon {...{ handleMenuClick, field: item }} />
                  </Box>
                ))
              )}
            </Box>
          </TableContainer>
          {/* Pagination */}
          {totalPages > 1 && (
            <PaginationBox
              isShortContent={isShortContent}
              {...{ totalPages, page, handleChangePage, StyledPaginationItem }}
            />
          )}
          <MenuActions
            {...{
              id: element?._id,
              handleView,
              handleEdit,
              handleDelete,
              anchorEl,
              handleMenuClose,
            }}
          />
          {/*Add,Edit,Delete Icons & function calls */}
        </Box>
        {/* {bulkUploadModal && (
          <BulkUploadModal
            onCloseBulkUpload={handleCloseBulkUpload}
            isBulkUploadModal={bulkUploadModal}
            excelData={excelData}
            fileName={"purchase goods"}
            setsnackOpen={setsnackOpen}
            url={"/scope3/emission/bulkUploadSPuchaseGoods"}
          />
        )} */}
        {bulkUploadModal && (
          <BulkUploadModal
            onCloseBulkUpload={handleCloseBulkUpload}
            isBulkUploadModal={bulkUploadModal}
            {...{
              setsnackOpen,
              excelData,
              setMatchData,
              formDataBulkUpload,
              setFormDataBulkUpload,
              setJsonBulkUpload,
            }}
            matchedKey="statusList"
            errorClose={uploadErrorClose}
            setBulkUploadModal={setBulkUploadModal}
            fileName={"Purchase Goods"}
            url={"/scope3/emission/bulkUploadSPuchaseGoods"}
          />
        )}
        {bulkUploadTable && (
          <EmissionBulkAdd
            matchData={matchData}
            inputData={inputData.slice(0, -3)}
            setMatchData={setMatchData}
            onClose={() => setBulkUploadTable(false)}
            bulkUploadTable={bulkUploadTable}
            {...{ formDataBulkUpload, setFormDataBulkUpload }}
            title1="Vendor"
            title2="Type of Activity"
            title3="Category Type"
            keyValue1="vendor"
            keyValue2="typeOfActivity"
            keyValue3="categoryType"
            matched1={"matchedVendor"}
            matched2={"matchedTypeOfActivityValue"}
            matched3={"matchedCategoryType"}
            options1={["Air Conditioning", "Refrigeration"]}
            options2={uniqueValues.typeOfActivity}
            options3={categoryData}
            onConfirm={() => {
              setBulkUploadTable(false);
              fetchData();
            }}
            url={`${api}/scope3/emission/bulkUploadJson`}
            jsonBulkUpload={jsonBulkUpload}
            bulkUploadUrl={`${api}/scope3/emission/jsonupload`}
            setsnackOpen={setsnackOpen}
          />
        )}
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default Emissions;
